// Hardcoded list of major Moldovan cities used as the location selector source.
// Replaces the former /locations/getLocations API call. Index 0 (Chișinău) is the default.
// Shape matches what SelectLocationResult/setMapMarkers expect:
//   { name, location: { longitude, latitude }, zoom }
const MOLDOVA_CITIES = [
  { name: 'Chișinău',  location: { longitude: 28.8353, latitude: 47.0105 }, zoom: 12 },
  { name: 'Bălți',     location: { longitude: 27.9292, latitude: 47.7615 }, zoom: 13 },
  { name: 'Cahul',     location: { longitude: 28.1903, latitude: 45.9075 }, zoom: 13 },
  { name: 'Ungheni',   location: { longitude: 27.8067, latitude: 47.2050 }, zoom: 13 },
  { name: 'Soroca',    location: { longitude: 28.2925, latitude: 48.1556 }, zoom: 13 },
  { name: 'Orhei',     location: { longitude: 28.8244, latitude: 47.3833 }, zoom: 13 },
  { name: 'Comrat',    location: { longitude: 28.6586, latitude: 46.2989 }, zoom: 13 },
  { name: 'Edineț',    location: { longitude: 27.3050, latitude: 48.1733 }, zoom: 13 },
  { name: 'Strășeni',  location: { longitude: 28.6056, latitude: 47.1467 }, zoom: 13 },
  { name: 'Căușeni',   location: { longitude: 29.4078, latitude: 46.6442 }, zoom: 13 },
]

export default MOLDOVA_CITIES
